import React from 'react'

const PLC = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Industrial Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>PLC</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/plc.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>PLCs (Programmable Logic Controllers):</h2>
                        <p className="mbot25">
                            We offer advanced PLCs designed to automate and control industrial machinery with
                            precision and reliability. Our PLC solutions are tailored to meet the specific needs
                            of your production environment, ensuring seamless operations.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PLC
